<!-- Start of Quick search filter -->
  <div class="row">
    <div class="col-lg-12">
      <div class="ui-grid-col-12">
        @for (filterRow of quickSearchDataArray; track filterRow; let f = $index) {
          <div [ngClass]="{'ui-g-12 ui-md-12': true, 'ui-lg-1': (!filterRow.isLarge && !filterRow.className), 'ui-lg-2': (filterRow.isLarge || filterRow.className), 'width_Percentage_1337': (filterRow.isLarge || filterRow.className), 'ui-lg-3': filterRow.isXLarge }">
            @if((filterRow.fieldtype | lowercase)!=='maskfield') {
              <input type="input" id="input_{{filterRow.columnname}}" [(ngModel)]="filterRow.values"
                placeholder="{{filterRow.label}}" (keyup.enter)="quickSearch()" class="inputBox form-control"
                [ngClass]="filterRow.className" />
            }
            
            @if((filterRow.fieldtype | lowercase)==='maskfield') {
              <p-inputMask id="input_{{filterRow.columnname}}" [(ngModel)]="filterRow.values" [mask]="filterRow.mask" [placeholder]="filterRow.placeholder" [slotChar]="filterRow.slotchar" [autoClear]="false" 
                (keyup.enter)="quickSearch()" class="mass-input-mask-field">
              </p-inputMask>
            }
          </div>
        }
        <div [ngClass]="{'ui-g-12 ui-md-12 ui-lg-1': true, 'autoWidth': true}">
          <button class="searchButton" id="search-button" (click)="quickSearch()" matTooltip="Search" [matTooltipShowDelay]="1000" matTooltipPosition="below">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <button class="clearButton" id="clear-button" (click)="clear()" matTooltip="Clear" [matTooltipShowDelay]="1000" matTooltipPosition="below">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Quick search filter -->